'use strict';

exports.__esModule = true;

var _reactRouter = require('react-router');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _reactRouter.MemoryRouter;
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/MemoryRouter.js
// module id = 795
// module chunks = 0